// //////////////////////////////////////////////////
    // LOADING SCREEN
  window.addEventListener('DOMContentLoaded', () => {
      setTimeout(() => {
        document.getElementById('loading').classList.add('hidden');
      }, 100); // smaller delay
    });
    
    // HEADER SCROLL
    const header = document.getElementById('header-main');
    window.addEventListener('scroll', () => {
      if (window.scrollY > 60) { header.classList.add('scrolled') } else { header.classList.remove('scrolled') }
    });



    // REVEAL ANIMATIONS
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, { threshold: .1, rootMargin: '0px 0px -50px 0px' });
    document.querySelectorAll('.reveal,.reveal-left,.reveal-right').forEach(el => revealObserver.observe(el));




    // CARD TILT EFFECT
    document.querySelectorAll('.product-card,.why-card,.testi-card').forEach(card => {
      card.addEventListener('mousemove', e => {
        const rect = card.getBoundingClientRect();
        const x = (e.clientX - rect.left) / rect.width - .5;
        const y = (e.clientY - rect.top) / rect.height - .5;
        card.style.transform = `translateY(-8px) rotateX(${-y * 8}deg) rotateY(${x * 8}deg)`;
        card.style.transition = 'transform .1s ease';
      });
      card.addEventListener('mouseleave', () => {
        card.style.transform = '';
        card.style.transition = 'transform .4s ease';
      });
    });

    // PARALLAX HERO GLOW
    window.addEventListener('scroll', () => {
      const s = window.scrollY;
      const glow = document.querySelector('.hero-glow');
      const glow2 = document.querySelector('.hero-glow2');
      if (glow) { glow.style.transform = `translateY(${s * 0.3}px) scale(${1 + s * 0.0002})` }
      if (glow2) { glow2.style.transform = `translateY(${s * -0.2}px)` }
    });

    // SMOOTH SCROLL
    document.querySelectorAll('a[href^="#"]').forEach(link => {
      link.addEventListener('click', e => {
        e.preventDefault();
        const target = document.querySelector(link.getAttribute('href'));
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    // FLOATING STATS COUNTER ANIMATION

    function animateCounter(el, target, finalText) {

      let start = 0;
      const duration = 1800;

      const step = (timestamp) => {

        if (!start) start = timestamp;

        const progress = Math.min((timestamp - start) / duration, 1);

        const val = Math.floor(progress * target);

        // 10K+
        if (finalText.includes('K')) {
          el.textContent = Math.floor(val / 1000) + 'K+';
        }

        // 24hr
        else if (finalText.includes('hr')) {
          el.textContent = val + 'hr';
        }

        // 500+
        else if (finalText.includes('+')) {
          el.textContent = val.toLocaleString() + '+';
        }

        // normal
        else {
          el.textContent = val.toLocaleString();
        }

        if (progress < 1) {
          requestAnimationFrame(step);
        } else {
          el.textContent = finalText;
        }
      };

      requestAnimationFrame(step);
    }

    const statsObserver = new IntersectionObserver(entries => {

      entries.forEach(entry => {

        if (entry.isIntersecting) {

          const nums = entry.target.querySelectorAll('.stat-num');

          nums.forEach(n => {

            const finalText = n.dataset.target || n.textContent;

            // extract number only
            const target = parseInt(finalText.replace(/\D/g, ''));

            animateCounter(n, target, finalText);

          });

          statsObserver.unobserve(entry.target);
        }
      });

    }, { threshold: 0.5 });

    const heroStats = document.querySelector('.hero-stats');

    if (heroStats) {
      statsObserver.observe(heroStats);
    }


// //////////////////////////////////////////////////////////////////////////////
    document.addEventListener("DOMContentLoaded", () => {

      const counters = document.querySelectorAll(".counter");

      counters.forEach(counter => {

        const target = parseFloat(counter.dataset.target);
        const isDecimal = target % 1 !== 0;

        let current = 0;
        const duration = 2000;
        const increment = target / (duration / 16);

        function updateCounter() {

          current += increment;

          if (current < target) {

            counter.innerText = isDecimal
              ? current.toFixed(1)
              : Math.floor(current);

            requestAnimationFrame(updateCounter);

          } else {

            counter.innerText = target;
          }
        }

        updateCounter();

      });

    });



    
 document.addEventListener('click', function(e){

    const btn = e.target.closest('.view-btn');

    if(!btn) return;

    const grid = document.querySelector('#gf-products');

    if(!grid) return;

    const view = btn.dataset.view;

    // remove old classes
    grid.classList.remove(
        'grid2-view',
        'grid3-view',
        'grid4-view',
        'list-view'
    );

    // mobile
    if(window.innerWidth <= 991){

        if(view === 'list-view'){

            grid.classList.add('list-view');

        } else {

            // all grid buttons = 2 columns in mobile
            grid.classList.add('grid2-view');

        }

    } else {

        // desktop normal views
        grid.classList.add(view);

    }

    // active button
    document.querySelectorAll('.view-btn').forEach(button=>{
        button.classList.remove('active');
    });

    btn.classList.add('active');

});

document.addEventListener("DOMContentLoaded", function () {

  function openFirstFilter() {
    const firstBlock = document.querySelector(".gf-option-block");

    if (!firstBlock) return;

    // remove collapse class
    firstBlock.classList.remove("is-collapsed");

    // open trigger
    const trigger = firstBlock.querySelector('[role="button"]');
    const content = firstBlock.querySelector(".gf-block-content");

    if (trigger) {
      trigger.setAttribute("aria-expanded", "true");
    }

    if (content) {
      content.style.display = "block";
      content.style.height = "auto";
      content.style.maxHeight = "none";
    }
  }

  // run immediately
  openFirstFilter();

  // ALSO run again (important for Globo re-render)
  const observer = new MutationObserver(() => {
    openFirstFilter();
  });

  const target = document.querySelector("#gf-tree");

  if (target) {
    observer.observe(target, {
      childList: true,
      subtree: true
    });
  }

});



